var React = require('react');

function CheckCircleOutline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M 12,0.02401376 C 5.4132075,0.02401376 0.02401376,5.4132075 0.02401376,12 0.02401376,18.586793 5.4132075,23.975986 12,23.975986 18.586793,23.975986 23.975986,18.586793 23.975986,12 23.975986,5.4132075 18.586793,0.02401376 12,0.02401376 Z M 12,21.580789 C 6.7185901,21.580789 2.419211,17.28141 2.419211,12 2.419211,6.7185901 6.7185901,2.419211 12,2.419211 c 5.28141,0 9.580789,4.2993791 9.580789,9.580789 0,5.28141 -4.299379,9.580789 -9.580789,9.580789 z M 17.496978,6.706614 9.6048028,14.598789 6.5030223,11.508984 4.8144083,13.197599 9.6048028,17.987994 19.185592,8.4072041 Z","style":{"strokeWidth":"1.1976"}}));
}

CheckCircleOutline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = CheckCircleOutline;

CheckCircleOutline.default = CheckCircleOutline;
